import React from "react";
import { Typography } from "@mui/material";

import LegalPage from "./LegalPage";
import LegalSection from "./LegalSection";
import { PLATFORM_NAME, PRIVACY_CONTACT_EMAIL } from "./legalContentConstants";

const SECTIONS = [
  { id: "what-are", title: "1. Cookies and browser storage" },
  { id: "necessary", title: "2. Strictly necessary" },
  { id: "preferences", title: "3. Preferences" },
  { id: "analytics", title: "4. Analytics and tracking" },
  { id: "third-party", title: "5. Third-party cookies" },
  { id: "managing", title: "6. Managing cookies" },
  { id: "changes", title: "7. Changes" },
];

const CookiePolicy = () => {
  return (
    <LegalPage
      title="Cookie & Storage Policy"
      intro={`This policy explains how the ${PLATFORM_NAME} uses cookies and browser storage.`}
      sections={SECTIONS}
    >
      <LegalSection id="what-are" title="1. Cookies and browser storage">
        <Typography variant="body1">
          Cookies are small files stored by your browser. Browser storage
          (localStorage) works in a similar way but stays on your device and is
          not sent to the server with every request. We use both to operate the
          Service.
        </Typography>
      </LegalSection>

      <LegalSection id="necessary" title="2. Strictly necessary">
        <Typography variant="body1">
          These are required for the Service to function and cannot be switched
          off. They include:
        </Typography>
        <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
          <li>
            <strong>Authentication tokens</strong> stored in browser storage
            (<code>auth_access_token</code>, <code>auth_refresh_token</code>,{" "}
            <code>auth_expires_at</code>) to keep you signed in.
          </li>
          <li>
            <strong>Session cookies</strong> set by our identity provider
            (Keycloak) during sign-in.
          </li>
        </Typography>
      </LegalSection>

      <LegalSection id="preferences" title="3. Preferences">
        <Typography variant="body1">
          We store a small number of preferences on your device to improve your
          experience, for example your selected language and your saved
          favourite solutions and action plans.
        </Typography>
      </LegalSection>

      <LegalSection id="analytics" title="4. Analytics and tracking">
        <Typography variant="body1">
          We do not currently use advertising or third-party analytics/tracking
          cookies. If this changes, this policy will be updated and, where
          required, consent will be requested before such cookies are set.
        </Typography>
      </LegalSection>

      <LegalSection id="third-party" title="5. Third-party cookies">
        <Typography variant="body1">
          Our identity provider (Keycloak) may set cookies when you sign in.
          These are necessary for authentication. TODO(legal): confirm any other
          third-party cookies set in your deployment.
        </Typography>
      </LegalSection>

      <LegalSection id="managing" title="6. Managing cookies">
        <Typography variant="body1">
          You can delete or block cookies and clear browser storage through your
          browser settings. Note that disabling strictly necessary cookies or
          storage may prevent you from signing in or using parts of the Service.
        </Typography>
      </LegalSection>

      <LegalSection id="changes" title="7. Changes">
        <Typography variant="body1">
          We may update this policy. Questions? Contact {PRIVACY_CONTACT_EMAIL}.
        </Typography>
      </LegalSection>
    </LegalPage>
  );
};

export default CookiePolicy;
